import React from 'react'
import { useGetPlanDetails } from 'hooks/useGetPlanDetails';
import PageTitle from 'components/PageTitle/PageTitle';
import { Card, CardContent } from '@mui/material';
import withRouter from 'hoc/withRouter';

const PlanDetails = ({ router: { params: { id } } }: any) => {
    const { data: plan, isLoading, error } = useGetPlanDetails(id);
    if (isLoading) return <div>Загрузка...</div>;
    if (error) return <div>Error: {error.message}</div>;
    return (
        <div className=' plan-details flex flex-col gap-4'>
            <PageTitle>Детали тарифа</PageTitle>
            <Card>
                <CardContent>
                    <div>
                        <div>Тариф {plan?.name}</div>
                    </div>
                </CardContent>
            </Card>
        </div>
    )
}

export default withRouter(PlanDetails);